const PomType = {
  GET_ALL_POM: 'GET_ALL_POM',
  UPDATE_POM: 'UPDATE_POM',
  DELETE_POM: 'DELETE_POM',
  GET_GRADING_LIST: 'GET_GRADING_LIST',
  GET_GRADING_NAME: 'GET_GRADING_NAME',
  GET_ALL_BRAND: 'GET_ALL_BRAND',
  GET_CATEGORY_ONE_DATA: 'GET_CATEGORY_ONE_DATA',
  GET_CATEGORY_TWO_DATA: 'GET_CATEGORY_TWO_DATA',
  GET_CATEGORY_THREE_DATA: 'GET_CATEGORY_THREE_DATA',
  GET_GRADING_GROUP_DATA_BY_ID: 'GET_GRADING_GROUP_DATA_BY_ID',
  GET_INSERTED_GROUP_ID: 'GET_INSERTED_GROUP_ID',
  FETCH_UNIT_OF_MEASURE: 'FETCH_UNIT_OF_MEASURE',
  SYSTEM_ECOMM_ACCESS: 'SYSTEM_ECOMM_ACCESS',
  ECOMM_SPEC_DATA: 'ECOMM_SPEC_DATA',
  CHECK_GRADING_REFERENCE: 'CHECK_GRADING_REFERENCE',
  DEFAULT_COMPANY_UNIT: 'DEFAULT_COMPANY_UNIT',
  UPDATE_EXCEL_DATA: 'UPDATE_EXCEL_DATA',
  GRADING_GROUP_LISTING_DATA: 'GRADING_GROUP_LISTING_DATA',
  CLEAR_GROUP_REDUCER: 'CLEAR_GROUP_REDUCER',
  CLEAR_GRADING_GROUP_REDUCER: 'CLEAR_GRADING_GROUP_REDUCER',
  POM_GROUP_DATA_BY_ID: 'POM_GROUP_DATA_BY_ID',
  POM_GROUPS_DATA: 'POM_GROUPS_DATA',
  POM_GROUPS_WITH_LIBRARIES: 'POM_GROUPS_WITH_LIBRARIES',
  GET_CATEGORY_FOUR_DATA: 'GET_CATEGORY_FOUR_DATA',
};

export default PomType;
